module.exports = __webpack_public_path__ + "img/man.0c3cc836.png";